import { Card } from 'primereact/card';
import placeHolder from '../../../src/assets/images/PlaceHolder.webp';
import { InputText } from 'primereact/inputtext';
import { useState, useEffect } from 'react';
import { useCatchResponse } from '../../utils/useCatchResponse';
import APIConstant from "../../utils/pathConstants";
import Loader from '../Shared/Loader/Loader';
import api from "../../utils/apiClient";
import CommonConfig from '../../utils/constant';
import { apiBase } from '../../utils/config';
import { useNavigate } from 'react-router-dom';
import { Dropdown } from 'primereact/dropdown';


const ChildrenList = () => {
    const { catchResponse } = useCatchResponse();
    const navigate = useNavigate();
    const [globalFilterValue, setGlobalFilterValue] = useState('');
    const [securityUserID, setSecurityUserID] = useState("");
    const [childreenList, setChildreenList] = useState([]);
    const [selectedYear, setSelectedYear] = useState({});

    const onGlobalFilterChange = (e) => {
        setGlobalFilterValue(e.target.value);
    };

    useEffect(() => {
        const loginData = CommonConfig.loginData();
        setSecurityUserID(loginData?._id);
        GetChildreenList(loginData);
    }, []);

    const GetChildreenList = async (userData) => {
        try {
            let data = {
                UserID: userData?._id
            }
            await api.post(APIConstant.path.getChildreenDetailList, data).then(async response => {
                let res = response;
                if (res.success) {
                    setChildreenList(res?.data);
                    setSelectedYear(userData?.SelectedAcademicYearList);
                    Loader.hide();
                }
            }).catch(err => {
                Loader.hide();
                console.log(err);
            });
        } catch (err) {
            console.log(err);
            catchResponse(err);
        }
    }

    const filteredData = childreenList?.filter((child) =>
        Object.values(child)
            .join(' ')
            .toLowerCase()
            .includes(globalFilterValue.toLowerCase())
    );

    const handleCardClick = async (id, name, userType) => {
        const selectedChild = childreenList.find(child => child?.id === id);
        const loginData = CommonConfig.loginData();
        if (!loginData.SelectedChildData) {
            loginData.SelectedChildData = {};
        }
        loginData.SelectedChildData._id = id;
        loginData.SelectedChildData.Name = name;
        loginData.SelectedChildData.UserType = userType;
        loginData.SelectedChildData.ProfilePhotoUrl = selectedChild?.ProfilePhotoUrl || '';
        loginData.SelectedChildData.AcademicDataList = selectedChild?.AcademicDataList || [];
        localStorage.setItem('ERPLoginData', JSON.stringify(loginData));
        await CommonConfig.getUserMenu(loginData, navigate, 'OnClick');
        setTimeout(() =>
            navigate(0), 500)
    }

    const handleYearChange = async (childId, e) => {
        setSelectedYear(prev => {
            const updated = {
                ...prev,
                [childId]: e.value
            };

            const loginData = CommonConfig.loginData();
            loginData.SelectedAcademicYearList = updated;
            localStorage.setItem(
                'ERPLoginData',
                JSON.stringify(loginData)
            );

            return updated;
        });
    };

    return (
        <div className='wayment-owner-dashboard et-master-page'>
            <div className="heading-area p-d-flex p-ai-center p-jc-between">
                <div className="p-d-flex p-ai-baseline">
                    <i className="pi pi-user"></i>
                    <h2>Childreen List</h2>
                </div>
                <div className="p-d-flex p-ai-center p-jc-between">
                    <div className="searchbar-area e-searchbar-area">
                        <i className="pi pi-search" />
                        <InputText
                            value={globalFilterValue}
                            onChange={onGlobalFilterChange}
                            placeholder="Global Search"
                        />
                    </div>
                </div>
            </div>
            <div className="p-grid">
                {filteredData?.map((child, index) => (
                    <div key={index}>
                        <Card title={child?.Name} className="shadow-3 mb-4" onClick={() => handleCardClick(child?.id, child?.Name, child?.UserType)} style={{ width: '250px', cursor: 'pointer', margin: '10px' }}>
                            <div className="flex align-items-center gap-2">
                                <img
                                    src={child?.ProfilePhotoUrl ? `${apiBase}/UserProfilePic/${child?.ProfilePhotoUrl}` : placeHolder}
                                    onError={(e) => {
                                        e.target.onerror = null;
                                        e.target.src = placeHolder;
                                    }}
                                    style={{ width: '200px', height: '150px', borderRadius: '50%', objectFit: 'cover' }}
                                />
                            </div>
                            <Dropdown
                                key={`selectedYear-${index}`}
                                className="p-w-100 p-mt-1"
                                name='selectedYear'
                                inputId='selectedYear'
                                value={selectedYear ? selectedYear[child?.id] : null}
                                options={child?.AcademicDataList || []}
                                onChange={(e) => handleYearChange(child?.id, e)}
                                optionLabel="label"
                                optionValue="_id"
                                placeholder="Select Academic Year"
                                filter
                                onClick={(e) => e.stopPropagation()}
                            />
                        </Card>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default ChildrenList;
